import { render, staticRenderFns } from "./PinSignatureSimple.vue?vue&type=template&id=6485ad8a"
import script from "./PinSignatureSimple.vue?vue&type=script&lang=js"
export * from "./PinSignatureSimple.vue?vue&type=script&lang=js"
import style0 from "./PinSignatureSimple.vue?vue&type=style&index=0&id=6485ad8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports